import script from "./SiteLoadingSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteLoadingSpinner.vue?vue&type=script&setup=true&lang=js"

import "./SiteLoadingSpinner.vue?vue&type=style&index=0&id=c84e9390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c84e9390"]])

export default __exports__